import { render, staticRenderFns } from "./Exwarehouse.vue?vue&type=template&id=a67ed8a0&scoped=true"
import script from "./Exwarehouse.vue?vue&type=script&lang=js"
export * from "./Exwarehouse.vue?vue&type=script&lang=js"
import style0 from "./Exwarehouse.vue?vue&type=style&index=0&id=a67ed8a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67ed8a0",
  null
  
)

export default component.exports